<div appDsTooltip
  class="recentSearchCard"
  [tooltip]="tooltipText"
  [visible]="activateTooltip"
  (click)="clicked.emit()">
  <div class="recentSearchCard__content">
    <div class="recentSearchCard__icon">
      <app-ds-icon
        [icon]="icon"
        [color]="iconColor"
        [size]="24">
      </app-ds-icon>
    </div>

    <div class="recentSearchCard__info">
      <ng-container [ngSwitch]="true">
        <ng-container *ngSwitchCase="dataType === recentSearchDataType.Flight || dataType === recentSearchDataType.Bus">
          <div class="recentSearchCard__info-upper">
            <app-ds-typography [fontFamily]="fontFamily.SemiBold" [size]="fontSize.XXS" [text]="from"></app-ds-typography>
            <app-ds-icon [icon]="flightTripIcon" [size]="16"></app-ds-icon>
            <app-ds-typography [fontFamily]="fontFamily.SemiBold" [size]="fontSize.XXS" [text]="to"></app-ds-typography>
          </div>
          <div class="recentSearchCard__info-down">
            <div class="recentSearchCard__info-down--dates">
              <app-ds-typography [size]="fontSize.XXXS" [text]="tripDates"></app-ds-typography>
            </div>
            <div class="recentSearchCard__info-down--pax">
              <app-ds-icon [icon]="icons.PersonOutline" [size]="16"></app-ds-icon>
              <app-ds-typography [size]="fontSize.XXXS" [text]="paxNumber"></app-ds-typography>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="dataType === recentSearchDataType.Hotel || dataType === recentSearchDataType.Packages || dataType === recentSearchDataType.ByHours">
          <div class="recentSearchCard__info-upper">
            <app-ds-typography [size]="fontSize.XXS" [text]="destination"></app-ds-typography>
          </div>
          <div class="recentSearchCard__info-down">
            <div class="recentSearchCard__info-down--dates">
              <app-ds-typography [size]="fontSize.XXXS" [text]="tripDates"></app-ds-typography>
            </div>
            <div class="recentSearchCard__info-down--pax">
              <app-ds-icon [icon]="icons.Bed" [size]="16"></app-ds-icon>
              <app-ds-typography [size]="fontSize.XXXS" [text]="roomNumber"></app-ds-typography>
            </div>
            <div class="recentSearchCard__info-down--pax">
              <app-ds-icon [icon]="icons.PersonOutline" [size]="16"></app-ds-icon>
              <app-ds-typography [size]="fontSize.XXXS" [text]="paxNumber"></app-ds-typography>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="dataType === recentSearchDataType.Cars">
          <div class="recentSearchCard__info-upper">
            <app-ds-typography [size]="fontSize.XXS" [text]="destination"></app-ds-typography>
          </div>
          <div class="recentSearchCard__info-down">
            <div class="recentSearchCard__info-down--dates">
              <app-ds-typography [size]="fontSize.XXXS" [text]="tripDates"></app-ds-typography>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>


  </div>
</div>